
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
      <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
      <b-row>
        <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
          <b-form-group
            label="Nom utilisateur"
            label-for="basicInput"
          >
            <validation-provider
              #default="{ errors }"
              name="Nom utilisateur"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.community_name"
                :plaintext="readOnly"
                placeholder="Nom utilisateur"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
          <b-form-group
            label="Photo"
            label-for="Photo"
          >
          
           <b-media vertical-align="top" v-if="file!==null">
                <template #aside>
                  <b-img
                    :src="file"
                    blank-color="#ccc"
                    width="64"
                    alt="placeholder"
                    
                  />
                </template>
                
                <b-card-text class="mb-0">
                  
                  <b-button
                  size="sm"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-warning"
                    class="btn-icon"
                    @click="editPhoto()"
                  >
                     <feather-icon icon="EditIcon" />
                  </b-button>
                </b-card-text>
              </b-media>
          <b-form-file v-else
          required
              v-model="file"
              :state="Boolean(file)"
              placeholder="Choisissez ou faites glisser un fichier..."
              drop-placeholder="Déposer ici ..."
              @change="fileAdded($event)"
             
          />
          
          </b-form-group>
        </b-col>

        <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
        <b-form-group
            label="ID Favoris"
            label-for="Prix"
          >
           <validation-provider
              #default="{ errors }"
              name="ID Favoris"
              rules="required"
            >
            <b-form-input
            required
              id="ID Favoris"
              v-model="favorite_id"
              :plaintext="readOnly"
              type="number"
              step="1"
              placeholder="ID Favoris"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
       
         <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
        
        </b-col>
        

      </b-row>
        </b-form>
      </validation-observer>

    </b-card>

  <b-button v-if="edition==false"
     @click="createCommunity" :disabled="invalid"
    >
    Enregistrer
    </b-button>

    <b-button v-else :disabled="invalid"
     @click="updateCommunity"
    >
    Enregistrer
    </b-button>

  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput, BForm,  BRow, BCol,BOverlay, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea,BCardText, BMedia, BImg} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest,Utils} from '@simb2s/senseye-sdk'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  name: 'CommunityPickForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BCardText, BMedia, BImg,
    BRow,
    BCol,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  directives: {
    Ripple,
  },
  data() {
      return {
          currentBase64:null,
          file: null,
         
          loading:true,
          favorite_id:null,
          edition:false,
          form:{
            community:true,
            community_name:"",
            community_photo:'',
          },
          validation: true,
          required
      }
  },
  props: ['favorite', 'readOnly'],
  methods:{
    editPhoto() {
      this.file=null
    },
   
    async createCommunity()
    {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        
        try {
          await APIRequest.update('favorites',this.favorite_id,this.form)
          
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Le community pick a bien été créée !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'community-picks'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
      })
      
    },
    async updateCommunity()
    {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.loading=true
         
          try {
            
            await APIRequest.update('favorites',this.favorite_id,this.form)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Le community pick a bien été modifiée !',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push({name:'commmunity-picks'})
          } catch (error) {
            this.loading=false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Une erreur est survenue.',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            })
            
          }
        }
      })
      
    },
    fileAdded(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
        
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase64=reader.result
              this.form.community_photo=this.currentBase64
          }
          else
          {
              this.file=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ceci n'est pas une image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
     
      
  },
  async mounted(){

  
    if(this.favorite!=null)
    {
      this.form.community_name=this.favorite.community_name
     this.favorite_id=this.favorite.id
      this.file=this.favorite.community_photo
      this.edition=true
      
    }
    this.loading=false
   }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>